<div *ngIf="conditionCategory as category"
     class="condition"
     [ngClass]="category.color">
  <span [nbTooltip]="category.tooltip"
        [nbTooltipStatus]="category.color">
  {{condition * 100 | number:'1.0-0'}}
  </span>
</div>
